<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-links">
      <a routerLink="/privacy-policy" class="footer-link">Privacy Policy</a>
      <span class="footer-separator">|</span>
      <a routerLink="/terms-and-conditions" class="footer-link">Terms and Conditions</a>
    </div>
    <div class="footer-brand">
      <span>© 2025 Stitch. All rights reserved.</span>
    </div>
  </div>
</footer>
